export const INVENTORY_CHANGED = 'stockflow:inventory-changed';
export interface InventoryChange { companyId: number; depositId?: number }

export function notifyInventoryChanged(change: InventoryChange) {
  window.dispatchEvent(new CustomEvent<InventoryChange>(INVENTORY_CHANGED, { detail: change }));
}
